import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '@aid/shared/components/snack-bar/snack-bar.component';
import { SnackBar } from '@aid/shared/types/classes/snack-bar.class';
import { SnackBarType } from '@aid/shared/types/enums/snack-bar-type.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { FormActionSaveTimeoutError } from '@aid/shared/operators';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  success(
    message: string,
    duration: number = 2000,
    translationData?: { [key: string]: string | number | undefined }
  ) {
    const snackBar: SnackBar = {
      message,
      type: SnackBarType.SUCCESS,
      translationData
    };
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration,
      panelClass: ['snackbar'],
      verticalPosition: 'bottom',
      horizontalPosition: 'left',
      data: snackBar
    });
  }

  info(message: string, duration: number = 2000) {
    const snackBar: SnackBar = {
      message,
      type: SnackBarType.INFORMATION
    };
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration,
      panelClass: ['snackbar'],
      verticalPosition: 'bottom',
      horizontalPosition: 'left',
      data: snackBar
    });
  }

  error(message: string, duration: number = 2000) {
    const snackBar: SnackBar = {
      message,
      type: SnackBarType.ERROR
    };
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration,
      panelClass: ['snackbar'],
      verticalPosition: 'bottom',
      horizontalPosition: 'left',
      data: snackBar
    });
  }

  /**
   * Displays an error from a form-action save unless the API interceptor has
   * already displayed the global 500 message for the same request.
   */
  errorFormAction(error: unknown, message?: string, duration: number = 2000) {
    if (error instanceof HttpErrorResponse && error.status === 500) {
      return;
    }
    const defaultMessage =
      error instanceof FormActionSaveTimeoutError
        ? 'form-action-save-timeout'
        : 'form-action-save-failed';
    this.error(message ?? defaultMessage, duration);
  }

  errorApi(error: HttpErrorResponse, duration: number = 6000) {
    const message = error.error.detail || 'error-went-wrong';
    this.error(message, duration);
  }
}
